import template from './suburban-building-status-land.jade';
import validation from '../../../services/validation';
import suburbanBuildingStatus from '../../../enums/suburban-building-status-land';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.commonSuburbanBuildingStatusLand', [])
  .directive('cianAfCommonSuburbanBuildingStatusLand', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'deviceService',
      'store',
      function (deviceService, store) {
        this.isMobile = deviceService.isMobile;
        this.suburbanBuildingStatusOptions = suburbanBuildingStatus;

        this.validation = validation(this.form, 'suburbanBuildingStatusLand', {
          required: 'Обязательное поле',
        });

        this.handleChange = () => {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'land_status');
        };
      },
    ],
    controllerAs: 'suburbanBuildingStatusLand',
    template,
  })).name;
